import { create } from "zustand";

interface TextState {
  texts: Record<string, string>;
  updateTexts: (newText: Record<string, string>) => void;
  getTextByKey: (key: string) => string;
}

const useTextStore = create<TextState>((set, get) => ({
  texts: {},

  updateTexts: (newTexts) => set({ texts: newTexts }),

  getTextByKey: (key) => {
    return get().texts[key] || key;
  },
}));

export default useTextStore;
